import {Drawer, IconButton, useMediaQuery} from "@mui/material";
import React, {useEffect} from "react";
import SidebarMenuList from "../../includes/sidebarMenuList";
import {isDesktop, drawerWidth} from "../constants";
import json2mq from "json2mq";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import BottomTab from "../hooks/BottomTab";
import LoginPopUp from "../alert/login/LoginPopUp";
import PromoBanner from "../../pages/promoBanner";

const Header2 = ({index, children, bottomNavigationMobile, topNavigationMobile}) => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const mediaQueryVar = useMediaQuery(json2mq(isDesktop));
    const [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [path, setPath] = React.useState("/");
    const location = useLocation();

    React.useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);
    const handleLoginClick = () => {
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const handleModalClose = () => {
        // Close the modal and reset the URL to the welcome page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };

    const [unreadAlerts, setUnreadAlerts] = React.useState(0);
    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);

    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
              display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });
        const [mobileOpen, setMobileOpen] = React.useState(false);
        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                         display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                             display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {topNavigationMobile.map((tab, index) => (
                            <Link to={tab.href} style={{textDecoration: "none", minWidth: "80px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window.constants.asset_path + tab.icon}
                                        alt="home"
                                        style={{
                                            marginRight: "3px",
                                            height: tab.icon_width || "18px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {!mediaQueryVar ? tab.mobile_name : tab.name}
                                </div>
                            </Link>
                        ))}

                        
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "20px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                                                tabs={bottomNavigationMobile}
                                                handleLoginClick={handleLoginClick}
                                            />
                </div>
            </div>
        );
    };

    return mediaQueryVar ? (
        <div className="col" style={{maxWidth: "315px"}}>
            <Drawer
                variant="permanent"
                open
                sx={{
                    display: {xs: "block"},
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                    <SidebarMenuList />
                </div>
            </Drawer>
        </div>
    ) : (
        <div>
            <div className="d-flex justify-content-between py-4 px-3">
                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0, // aligns it to the right of the sidebar
                                        width: "100%", // takes full width minus sidebar
                                        backgroundColor: "#ffffff",
                                        zIndex: 1000,
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        height: "100px",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <PromoBanner />
                                    <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                </div>
            </div>
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{keepMounted: true}}
                sx={{
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                <SidebarMenuList />
            </Drawer>
            {isLoginModalOpen && (
                <LoginPopUp
                    // isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                    onClose={handleModalClose}
                />
            )}
        </div>
    );
};

export default Header2;
